// this is an autogenerated file from DesignSystem/SendPatientSignatureRequestMessage/Recipients/data.graphql
import { gql } from 'Data/Api'

export default gql`
query app__DesignSystem_SendPatientSignatureRequestMessage_Recipients(
  $id: numeric!
  $include_professionals: Boolean!
  $include_external_professionals: Boolean!
) {
  vaxiom_patients_by_pk(id: $id) {
    id
    _id
    person {
      id
      _id
      first_name
      last_name

      to_person_relationships(where: { permitted_to_see_info: { _eq: true } }) {
        id
        type
        from_person_record {
          id
          _id
          first_name
          last_name
        }
      }
    }

    professional_relationships @include(if: $include_professionals) {
      id
      dtype
      employee {
        id
        provider {
          id
          employee_resources(where: { invalid: { _eq: false } }) {
            id
            employment_contract {
              id
              person {
                id
                _id
                first_name
                last_name
              }
            }
          }
        }
      }

      other @include(if: $include_external_professionals) {
        id
        person {
          id
          _id
          first_name
          last_name
        }
      }
    }
  }
}

`